import { styled } from 'linaria/react';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
